var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeMobileShortNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 14.001,
  viewBox: "0 0 12 14.001",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.5.5V8a2.5 2.5 0 1 1-1-.792L10.5 3.596 4.986 6.982l-.108.066-.16.098-.107.066-.11.068L4.5 10a2.5 2.5 0 1 1-1-.792V4.788a.5.5 0 0 1 .239-.427l7-4.286a.5.5 0 0 1 .761.427m-9 9.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m7-2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m1-6.607-6 3.674v1.039l.015-.009c.751-.46 1.83-1.123 5.985-3.676z"
})));
export default SvgYoutubeMobileShortNote;